import {
  OPEN_PANEL,
  CLOSE_PANEL,
  SET_EXPANDED_ID,
  SET_PREVIEW_IMAGE,
  CLEAR_ACTIVE_PREVIEW,
  MARK_AS_READ,
  SET_ACTIVE_PREVIEW

} from "./ai.actionTypes"

const initialState = {
  isOpen: false,
  expandedId: null,
 previewImages: {},
 activePreviewId: null,
  readInsights: {},
};

export const insightsReducer = (state = initialState, action) => {
  switch (action.type) {
   case OPEN_PANEL:
  return {
    ...state,
    isOpen: true,
   
  };


    case CLOSE_PANEL:
      return { ...state, isOpen: false,  expandedId: null, previewImage: null };


    case SET_EXPANDED_ID:
      return { ...state, expandedId: action.payload };

case SET_PREVIEW_IMAGE:
  return {
    ...state,
    previewImages: {
      ...state.previewImages,
      [action.payload.insightId]: action.payload.url,
    },
      activePreviewId: action.payload.insightId,
  };

case SET_ACTIVE_PREVIEW:
  return {
    ...state,
    activePreviewId: action.payload.insightId,
  };



    case CLEAR_ACTIVE_PREVIEW:
      return { ...state, activePreviewId: null };


    case MARK_AS_READ:
      return {
        ...state,
        readInsights: {
          ...state.readInsights,
          [action.payload]: true,
        },
      };

    default:
      return state;
  }
};
